import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '../utilities/utilities';

@Pipe({name: 'salonMonsterDate'})
export class SalonMonsterDatePipe implements PipeTransform {
  transform(value: Date, format: string = 'Y-MM-DD HH:mm:ss') : string {
    return Utilities.formatDate(value, format);
  }
}